module.exports = __webpack_public_path__ + "static/media/cartaz2.0969857f.png";